import { render, staticRenderFns } from "./ProductCongratulations.vue?vue&type=template&id=212ca097&scoped=true&"
import script from "./ProductCongratulations.vue?vue&type=script&lang=js&"
export * from "./ProductCongratulations.vue?vue&type=script&lang=js&"
import style0 from "./ProductCongratulations.vue?vue&type=style&index=0&id=212ca097&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ca097",
  null
  
)

export default component.exports